import myAxios from './myAxios';

export function reportItem({ itemType, itemId, description }) {
  return myAxios.post('/report/report/', {
    reported_type: itemType,
    reported_id: itemId,
    description,
  });
}

export function reportBug({ description }) {
  return myAxios.post('/report/bug-report/', {
    description,
  });
}
